type Overrides = {
  title?: string;
  headTitle?: string;
  headDescription?: string;
};

export const getTagOverrides = (slug: string): Overrides => {
  const overrides: Record<string, Overrides> = {
    hiraoka: {
      title: '【公式】平岡義博コーチの卓球レッスン動画・理論の解説動画',
      headTitle:
        '【公式】平岡義博コーチの卓球レッスン動画・理論の解説動画 | 卓球動画シェークハンズ',
      headDescription:
        '平岡義博（ひらおかよしひろ）コーチによる卓球理論・指導動画です。元明治大学体育会卓球部監督 / FLAT HILL代表 / 宇田幸矢選手らの指導など、幅広く卓球に関わった経験を活かしたレッスン動画は必見です。',
    },
    'largesize-ball': {
      headTitle: '【卓球】ラージボールの卓球動画 大野さゆり・池田亘通が解説',
      headDescription:
        'ラージボールとは、通常の公式卓球より少し大きい直径44ミリの軽い卓球ボールのことです。ラリーが続き、回転数も少ないのが特徴です。初心者向けのテクニックを大野さゆり選手・池田亘通選手が解説します。',
    },
    smash: {
      title: '【卓球】スマッシュの打ち方・練習方法に関する卓球レッスン動画',
      headTitle:
        '【卓球】スマッシュの打ち方・練習方法を動画で解説 初心者にもおすすめ',
      headDescription:
        '卓球でのスマッシュは決定打として使います。スマッシュを上達するための初心者にもおすすめの練習方法も動画で紹介中！ドライブにスマッシュを組み合わせて予測されにくいプレーを身につけましょう。',
    },
    omote: {
      headTitle:
        '【卓球】表ソフトの打ち方・戦術を動画で解説 フォア表/サーブ/ドライブ',
      headDescription:
        '卓球で表ソフトラバーを使う場合のフォア、バック、ドライブ、ブロックなどの技術を動画で紹介します。表ソフトの技術を安藤みなみ選手・林幸菜選手・川口陽陽選手らが解説。',
    },
    'yokoyama-yuichi': {
      headTitle: '【卓球】横山友一選手の卓球テクニック解説動画を配信中！',
      headDescription:
        '横山友一選手による卓球技術の解説動画を配信中！2008年 全日本卓球男子ダブルス準優勝・国内外で活躍した横山友一選手がフォア・バック・レシーブ技術を動画でわかりやすく解説します！',
    },
    serve_oji: {
      headTitle: '【卓球】王子サーブの打ち方を森薗政崇選手が動画で解説',
      headDescription:
        '卓球の王子サーブ・しゃがみこみサーブの打ち方を森薗政崇選手らが動画で解説！試合でどうしても1点を取りたい時、頼りになるサーブをマスターしたい方は必見です。',
    },
    tsubudaka: {
      headTitle:
        '【卓球】粒高ラバーでのフォア・バック・レシーブ技術を動画で解説！',
      headDescription:
        '粒高ラバーを使っている選手向けの動画です。粒高ラバー相手の回転の影響を受けにくい分クセがあります。塩野真人選手はバック面に粒高ラバーを使っており、フォア前レシーブでも粒高ラバーを利用します。',
    },
    template: {
      title: '',
      headTitle: '',
      headDescription: '',
    },
  };

  if (slug in overrides) {
    return overrides[slug] as Overrides;
  }

  return {};
};
